<h3>Uw {{ productName }}</h3>
<table class="table-data table-data--polis" *ngIf="purchasedProduct">
    <colgroup>
        <col width="33%" />
        <col width="33%" />
        <col width="33%" />
    </colgroup>
    <tbody>
        <tr>
            <td>Naam</td>
            <td>{{ purchasedProduct?.product?.pet?.petName }}</td>
            <td></td>
        </tr>
        <tr *ngIf="purchasedProduct?.product?.pet?.chipNumber">
            <td>Chipnummer</td>
            <td>{{ purchasedProduct?.product?.pet?.chipNumber }}</td>
            <td></td>
        </tr>
        <tr>
            <td>Geboortedatum</td>
            <td>{{ purchasedProduct?.product?.pet?.birthdate | dateFormat }}</td>
            <td></td>
        </tr>
        <tr>
            <td>Geslacht</td>
            <td>
                <span [ngSwitch]="purchasedProduct?.product?.pet.genderCode">
                    <span *ngSwitchCase="genderCodeEnum.Male">
                        <span *ngIf="purchasedProduct?.product?.pet?.petCode === 'H'">Reu</span>
                        <span *ngIf="purchasedProduct?.product?.pet?.petCode === 'K'">Kater</span>
                    </span>
                    <span *ngSwitchCase="genderCodeEnum.Female">
                        <span *ngIf="purchasedProduct?.product?.pet?.petCode === 'H'">Teef</span>
                        <span *ngIf="purchasedProduct?.product?.pet?.petCode === 'K'">Poes</span>
                    </span>
                </span>
            </td>
            <td></td>
        </tr>
        <tr *ngIf="purchasedProduct?.product?.pet?.veterinarianName">
            <td>Dierenarts</td>
            <td>{{ purchasedProduct?.product?.pet?.veterinarianName }}</td>
            <td></td>
        </tr>
    </tbody>
</table>
